// Recovered compiled webpack factory 60343. Edit this function expression; run npm run build.
// Cloud-service-only view retired in the local studio; preserve its import/export boundary.
(module, exports, require) => {
  "use strict";
  require.d(exports, { PricingPlans: () => ServiceOnlyView });
  function ServiceOnlyView() { return null; }
}
